import { createStore } from "vuex";

export default createStore({
  state: {
    s3_file: "https://peterbear-wordking.s3.ap-northeast-1.amazonaws.com/pbt/IP/resources/",
    // s3_file: "https://nxidea.myds.me:4400/peter_bear/json/",
    
    api_file:"https://pbt.nxidea.com.tw/api/db/",
    path:"https://pbt.nxidea.com.tw/",
    json_path:"https://pbt.nxidea.com.tw/",

    // api_file:"https://nxidea.myds.me:4400/eric/peterbear/",
    // path:"https://nxidea.myds.me:4400/eric/peterbear/",
    // json_path:"https://nxidea.myds.me:4400/eric/peterbear/"

  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
